import React from "react";
import KickImage from 'Reuseables/KickImage';
import {
  Row,
  Col,
  Button,
  Modal,
  Input,
  InputGroup,
  Form,
  FormGroup,
} from "reactstrap";
import CloseIcon from "../../images/close-button-white.png";
import plusButton from "../../images/plus-button.png";

const ModalAddressBook = (props) => {
  const { data = [] } = props.dataAddress || {};
  const { countries, provinces, cities } = props;

  return (
    <Modal
      // className="modal-cashout"
      modalClassName="modal-address"
      // wrapClassName="wrapper-search"
      // contentClassName="content-search"
      // backdropClassName="backdrop-checkout-content"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <div className="address-header">
        <div onClick={props.onToggle} className="icon-close">
          <KickImage className="btn-close-modal" src={CloseIcon} alt="close" />
        </div>
        {/* <p onClick={props.onToggle} style={{color: '#fff', textAlign:'right', cursor: 'pointer'}}>close</p> */}
        <div className="text-title">
          <p>{props.titleModal}</p>
        </div>
      </div>
      <div className="address-content">
        {data.length > 0 && data.map((item, index) => {
          let selectedProvince = provinces && provinces.data.find(
            (p) => p.name === item.province
          );

          let selectedCountry =
            countries && countries.data
              ? countries.data.find((c) => c.code3 === item.country)
              : null;

          let selectedItem = {
            ...item,
            id_province: selectedProvince ? selectedProvince.id : null,
            //city: selectedCity.id
          };
          return (
            <Row key={item.id}>
              <Col sm={6} md={8} lg={10}>
                <p>
                  {item.alias} - {item.full_name}
                </p>
                <p>{item.phone_number}</p>
                <p>{item.street_address}</p>
                <p>{item.note}</p>
                <p>
                  {item.city}, {item.province}, {item.postal_code}
                </p>
                <p>{selectedCountry ? selectedCountry.name : null}</p>
              </Col>
              {props.id === item.id ? (
                <Col sm={6} md={4} lg={2}>
                  <p>DEFAULT</p>
                </Col>
              ) : (
                <Col sm={6} md={4} lg={2} style={{ cursor: "pointer" }}>
                  <p onClick={() => props.selectedAddress(selectedItem)}>
                    USE THIS
                  </p>
                </Col>
              )}
            </Row>
          );
        })}
        {data.length <= 0 ? (
          <Row style={{ display: "flex", justifyContent: "center" }}>
            <h6 style={{ marginBottom: "0" }}>
              Please input a shipping address.
            </h6>
          </Row>
        ) : null}
      </div>
      <div className="address-footer">
        <Row className="row-bottom">
          {/* <Col>
            <div onClick={props.onToggle} style={{cursor: 'pointer'}}>
              <span>&lt;&lt; Go Back</span>
            </div>
          </Col> */}
          <Col className="col-address-book">
            <div
              className="address-book-wrapper"
              onClick={props.handleClickAddress}
            >
              <KickImage src={plusButton} />
              <span>Add New Address</span>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalAddressBook;
